import * as stylex from '@stylexjs/stylex'
import { type HTMLAttributeAnchorTarget, type ElementType } from 'react'
import { Text, type TextProps } from '../Text/Text'
import { colors } from '../tokens/colors.stylex'

const baseStyles = stylex.create({
  root: {
    textDecoration: 'none',
    cursor: 'pointer',
  },
  underline: {
    textDecoration: 'underline',
  },
})

export type LinkProps<RootComponent extends ElementType = 'a', TextElement extends HTMLElement = HTMLLinkElement> = TextProps<RootComponent, TextElement> & {
  /** 連結開啟方式（如 '_blank'） */
  target?: HTMLAttributeAnchorTarget
  /** 連結的 rel 屬性；target='_blank' 時預設為 'noopener noreferrer' */
  rel?: HTMLLinkElement['rel']
  /**
   * 是否顯示底線
   * @default false
   */
  underline?: boolean
}

/**
 * Link 超連結元件，基於 Text 實作，預設渲染為 `<a>` 標籤。
 * 支援底線切換與自動設定安全的 rel 屬性。
 */
export const Link = <RootComponent extends ElementType = 'a', TextElement extends HTMLElement = HTMLLinkElement>(props: LinkProps<RootComponent, TextElement>) => {
  const {
    component = 'a',
    rootStyle,
    color = colors.blue600,
    underline = false,
    target,
    rel = target === '_blank' ? 'noopener noreferrer' : undefined,
    ...rest
  } = props

  return (
    <Text
      component={component}
      target={target}
      rel={rel}
      color={color}
      rootStyle={[
        baseStyles.root,
        underline && baseStyles.underline,
        rootStyle,
      ]}
      {...rest}
    />
  )
}
